var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { staticClass: "full__video" }, [
        _c("div", { staticClass: "intro__content intro__content--mobile" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              "data-srcset":
                "https://cdn.flixel.com/static/static-web/products/persecond/persecond@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecond.png 1x"
            }
          }),
          _c("h2", [_vm._v("Create beautiful time lapses effortlessly")]),
          _c(
            "div",
            {
              staticClass: "btn__group btn__group--splash btn__group--persecond"
            },
            [
              _c("download-trial-button", {
                attrs: {
                  product: "persecond",
                  classes: "btn btn--blue",
                  copy: "Download free trial"
                }
              }),
              _c("get-plan", {
                attrs: {
                  classes: "btn btn--white btn__splash",
                  isPersecond: "true"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "fluid__video" }, [
          _c("div", { staticClass: "intro__content intro__content--desktop" }, [
            _c("img", {
              staticClass: "lazy",
              attrs: {
                "data-srcset":
                  "https://cdn.flixel.com/static/static-web/products/persecond/persecond@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecond.png 1x"
              }
            }),
            _c("h2", [_vm._v("Create beautiful time lapses effortlessly")]),
            _c(
              "div",
              { staticClass: "btn__group btn__group--persecond" },
              [
                _c("download-trial-button", {
                  attrs: {
                    product: "persecond",
                    classes: "btn btn--blue",
                    copy: "Download free trial"
                  }
                }),
                _c("get-plan", {
                  attrs: { classes: "btn btn--white", isPersecond: "true" }
                })
              ],
              1
            )
          ]),
          _c("iframe", {
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/d2dkm41ovvcksq2yf71v?hd=true",
              allow: "autoplay"
            }
          }),
          _vm._m(0)
        ])
      ]),
      _c("brands"),
      _c("section", [
        _c(
          "div",
          { staticClass: "product__section product__section--reverse" },
          [
            _c("div", { staticClass: "product__section--content" }, [
              _vm._m(1),
              _c("div", { staticClass: "productItem__desc" }, [
                _c("p", [
                  _vm._v(
                    "Make life move fast, even faster. Use Persecond to easily transform your images into a unique time lapse."
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "btn__group" },
                  [
                    _c("download-trial-button", {
                      attrs: {
                        product: "persecond",
                        classes: "btn btn--blue",
                        copy: "Download free trial"
                      }
                    }),
                    _c("get-plan", {
                      attrs: { classes: "btn btn--white", isPersecond: "true" }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._m(2)
          ]
        )
      ]),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _c("section", { staticClass: "flixelPlan__section" }, [
        _c("div", { staticClass: "flixelPlan__container" }, [
          _c("h1", [_vm._v("Choose a plan that’s right for you")]),
          _c("p", [
            _vm._v(
              "Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform."
            )
          ]),
          _c(
            "div",
            { staticClass: "btn__group" },
            [
              _c("get-plan", {
                attrs: { classes: "btn btn--white", isPersecond: "true" }
              })
            ],
            1
          )
        ])
      ]),
      _vm._m(7),
      _c("script", { attrs: { type: "application/ld+json" } }, [
        _vm._v(_vm._s(this.$metaInfo))
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "credit" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://flixel.com/Lensofadventure/"
          }
        },
        [_vm._v("Lensofadventure")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "productItem__title" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          "data-srcset":
            "https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x"
        }
      }),
      _c("h2", [_vm._v("Persecond"), _c("span", [_vm._v("for macOS")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "product__section--image",
        attrs: { id: "persecondImage" }
      },
      [
        _c("img", {
          staticClass: "lazy persecondImage",
          attrs: {
            "data-srcset":
              "https://cdn.flixel.com/static/static-web/products/persecond/persecondproduct@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecondproduct.png 1x"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "product__section" }, [
        _c("div", { staticClass: "product__section--video" }, [
          _c("div", { staticClass: "video__text" }, [
            _c("h2", [_vm._v("Mesmerizing Time Lapses in 3 Steps")]),
            _c("p", [
              _vm._v(
                "Persecond makes time lapse creation simple. Transform your image set into a cinematic time lapse in just 3 steps. "
              )
            ])
          ]),
          _c(
            "video",
            {
              staticClass: "persecond video",
              attrs: {
                width: "auto",
                height: "auto",
                loop: "loop",
                autoplay: "autoplay",
                playsinline: "playsinline"
              }
            },
            [
              _c("source", {
                attrs: {
                  src:
                    "https://cdn.flixel.com/static/static-web/products/persecond/persecond.mp4",
                  type: "video/mp4"
                }
              })
            ]
          ),
          _c("div", { staticClass: "video__details" }, [
            _c("div", { staticClass: "detail" }, [
              _c("div", { staticClass: "detail--title" }, [
                _c("h3", [_vm._v("Be the Director")])
              ]),
              _c("div", { staticClass: "detail--desc" }, [
                _c("p", [
                  _vm._v(
                    "Capture your image set. Think about how each element, from motion to framing will influence your story. When you’re happy with it, import your image set into Persecond. "
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "detail" }, [
              _c("div", { staticClass: "detail--title" }, [
                _c("h3", [_vm._v("Shape Your Story")])
              ]),
              _c("div", { staticClass: "detail--desc" }, [
                _c("p", [
                  _vm._v(
                    "Edit your time lapse to tell your story in the best way possible. Select the in and out points of your time lapse, set the movement to forwards or backwards and pick the overall speed so that the motion is just right."
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "detail" }, [
              _c("div", { staticClass: "detail--title" }, [
                _c("h3", [_vm._v("Share It")])
              ]),
              _c("div", { staticClass: "detail--desc" }, [
                _c("p", [
                  _vm._v(
                    "It’s time for the world to see your beautiful time lapse. Export in broadcast quality using ProRes. Share it on social, or use your time lapse in a larger video production. You can even create a cinemagraph out of your time lapse. Show your view of life, perfectly sped up, in no time at all."
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "product__section product__section--carousel" },
      [
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--wide" },
          [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/d1qb0eqtqxu8l6b6rf54?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--thin" },
          [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/qu9t351e6la6w39u7j7s?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--wide" },
          [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/pm1yda3zkbjvvfpla1jx?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c("div", { staticClass: "carousel--mobile" }, [
          _c("iframe", {
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/6gtn5x2dvh413czlixth?hd=true",
              allow: "autoplay"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "carousel__attributions" }, [
      _c("h2", [_vm._v("Check out more by the artists featured here.")]),
      _c("div", { staticClass: "attributions" }, [
        _c(
          "a",
          {
            attrs: { href: "https://flixel.com/aaroncoury/", target: "_blank" }
          },
          [_vm._v("aaroncoury")]
        ),
        _c(
          "a",
          {
            attrs: { href: "https://flixel.com/savageian/", target: "_blank" }
          },
          [_vm._v("savageian")]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://flixel.com/robertlendvai/",
              target: "_blank"
            }
          },
          [_vm._v("robertlendvai")]
        )
      ]),
      _c("div", { staticClass: "attributions--mobile" }, [
        _c(
          "a",
          { attrs: { href: "https://flixel.com/CinePix/", target: "_blank" } },
          [_vm._v("CinePix")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "product__section" }, [
        _c("div", { staticClass: "product__section--cta" }, [
          _c("div", { staticClass: "productItem__title--cta" }, [
            _c("h2", [
              _vm._v(
                "Create Time Lapse Cinemagraphs with Persecond and Cinemagraph Pro"
              )
            ])
          ]),
          _c("div", { staticClass: "productItem__desc--cta" }, [
            _c("p", [
              _vm._v(
                "Transform time lapses created with Persecond into thumb-stopping cinemagraphs using Flixel Cinemagraph Pro for macOS and iOS. Get inspired by time lapse cinemagraphs created by the Flixel Community."
              )
            ]),
            _c("div", { staticClass: "btn__group" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn--blue",
                  attrs: { href: "/cinemagraphs/timelapse" }
                },
                [_vm._v("View Gallery")]
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", { staticClass: "product__section" }, [
        _c("div", { staticClass: "product__section--specs" }, [
          _c("h2", [_vm._v("System Requirements")]),
          _c("p", [
            _vm._v(
              "macOS 10.12.2 Sierra or later, 4GB of RAM (8GB recommended for 4K), Metal-capable graphics card"
            ),
            _c(
              "a",
              { attrs: { href: "https://support.apple.com/en-us/HT205073" } },
              [_vm._v("(Macs from 2012 or later),")]
            ),
            _vm._v(
              " 256MB of VRAM (1GB recommended for 4K), 1GB of disk space."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94ece44c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94ece44c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/mac-fps.vue
// module id = null
// module chunks = 